/**
 * JavaScript Utility - isEmpty
 * @author 서명환 <mhseo@ulalalab.com>
 */
import { isNull, isObject } from '.';

function isEmpty(value, isAllowEmptyString = false) {
  return (
    isNull(value) ||
    (!isAllowEmptyString && value === '') ||
    (Array.isArray(value) && value.length === 0) ||
    (isObject(value) && Object.keys(value).length === 0)
  );
}

export default isEmpty;
